import { useCallback } from 'react';
import { useStore } from 'zustand';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import { inventoryStore } from '../../../../InventoryStore';

export const useInventoryActions = () => {
  const form = useStore(inventoryStore, (state) => state.form);
  const setIsEditMode = useStore(
    inventoryStore,
    (state) => state.setIsEditMode
  );

  const clearAllPeriods = useStore(
    inventoryStore,
    (state) => state.clearAllPeriods
  );

  const setPricingDrawerOpen = useStore(
    inventoryStore,
    (state) => state.setPricingDrawerOpen
  );

  const tab = useStore(inventoryStore, (state) => state.tab);

  const onEdit = useCallback(() => {
    amplitudeTrack('Click Edit Extranet', { tab: tab.name });
    setIsEditMode(true);
  }, [setIsEditMode, tab]);

  const onCancel = useCallback(() => {
    amplitudeTrack('Click Cancel Extranet');
    clearAllPeriods();

    form?.resetFields();
    setIsEditMode(false);
  }, [clearAllPeriods, form, setIsEditMode]);

  const onSave = useCallback(async () => {
    if (!form) {
      console.error('Form instance not available');

      return;
    }

    try {
      await form.validateFields();
      amplitudeTrack('Click Save Extranet');
      form.submit();

      setIsEditMode(false);
    } catch (error) {
      console.error('Error saving inventory:', error);
    }
  }, [form, setIsEditMode]);

  const onPricingConfiguration = useCallback(() => {
    amplitudeTrack('Click Configure Pricing', { tab: tab.name });
    setPricingDrawerOpen(true);
  }, [setPricingDrawerOpen, tab]);

  return {
    onEdit,
    onCancel,
    onSave,
    onPricingConfiguration,
  };
};
